module.exports = __webpack_public_path__ + "img/dashboard-register.d915bc31.svg";